module.exports = __webpack_public_path__ + "assets/img/f13.89ecae60.png";